import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FleetVehicle, FLEET_STATUS_META } from '../../mock/models/fleet.models';

@Component({
  selector: 'app-fleet-side-panel',
  templateUrl: './fleet-side-panel.component.html',
  styleUrl: './fleet-side-panel.component.css',
})
export class FleetSidePanelComponent {
  @Input() vehicles: FleetVehicle[] = [];
  @Input() selectedId: string | null = null;
  @Output() select = new EventEmitter<FleetVehicle>();

  readonly statusMeta = FLEET_STATUS_META;
  searchText = '';

  get filtered(): FleetVehicle[] {
    const q = this.searchText.trim().toLowerCase();
    if (!q) return this.vehicles;
    return this.vehicles.filter((v) => {
      const plate = (v.plate ?? '').toLowerCase();
      const brand = `${v.brand} ${v.vehicle_model ?? ''}`.toLowerCase();
      return plate.includes(q) || brand.includes(q);
    });
  }

  onSelect(v: FleetVehicle): void {
    this.select.emit(v);
  }

  trackById(_: number, v: FleetVehicle): string {
    return v.id;
  }
}
